const searchFilter = (sourceStrs, searchStr) => {
  // check that all searchStr words 'starts with' in at least one of the source strings
  // e.g. searching 'ab de' should match a record with values ['abc', 'def']
  const sourceStrings = sourceStrs.filter(s => s != null)
  const searchStrings = searchStr.split(' ').filter(f => f !== '')
  return searchStrings.every(ss => {
    return (
      sourceStrings.findIndex(source =>
        source
          .toLowerCase()
          .split(' ')
          .some(s => s.startsWith(ss.toLowerCase()))
      ) != -1
    )
  })
}
export { searchFilter }
